import styled from 'styled-components';

export const CardStyled = styled.div<{ isActive: boolean }>`
	position: relative;
	margin-top: 24px;
	padding: 24px;
	border: 2px solid ${props => (props.isActive ? `#52C41A` : `#f0f0f0`)};
	border-radius: 10px;
	background-color: ${props => (props.isActive ? `#F6FFED` : `#fff`)};
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: 328px;
		padding: 16px;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 360px;
		padding: 24px;
	}
`;

export const CardHeadingContainerStyled = styled.div`
	gap: 4px;
	display: flex;
	flex-direction: column;
	margin-bottom: 24px;
`;
export const TariffNameStyled = styled.h2`
	margin-bottom: 4px;
	font-weight: 600;
  @media (min-width: ${props => props.theme.breakpoints.xs}) {
    font-size: 24px;
  }
  @media (min-width: ${props => props.theme.breakpoints.sm}) {
    font-size: 30px;
`;
export const TariffPriceStyled = styled.h4`
	margin-bottom: 0;
	font-weight: 600;
	font-size: 20px;
`;

export const FeaturesListStyled = styled.div`
	gap: 4px;
	display: flex;
	flex-direction: column;
`;
